module.exports = __webpack_public_path__ + "img/mypage05.b003e2ab.png";